import { createRoot } from "react-dom/client";
import { App } from "components/App";
import { APP_CONTAINER_CLASSNAME, APP_ROOT_CLASSNAME, POPUP_CLASSNAME } from "constants/common.constants";
import { APP_FONTS_REGISTER_STYLESHEET_HREF, APP_FONTS_STYLESHEET_HREF, APP_STYLESHEET_HREF } from "utils/url.utils";

const createInitialNodes = (): {
  appContainer: HTMLDivElement;
  appRoot: HTMLDivElement;
  modalNode: HTMLDivElement;
  appStylesheetNode: HTMLLinkElement;
  fontsRegisterStylesheetNode: HTMLLinkElement;
  fontsStylesheetNode: HTMLLinkElement;
} => {
  const appContainer = document.createElement("div");
  appContainer.classList.add(APP_CONTAINER_CLASSNAME);
  appContainer.setAttribute("data-version", __APP_VERSION__);

  const appRoot = document.createElement("div");
  appRoot.classList.add(APP_ROOT_CLASSNAME);

  const modalNode = document.createElement("div");
  modalNode.classList.add(POPUP_CLASSNAME);

  const appStylesheetNode = document.createElement("link");
  appStylesheetNode.type = "text/css";
  appStylesheetNode.rel = "stylesheet";
  appStylesheetNode.href = APP_STYLESHEET_HREF;

  const fontsRegisterStylesheetNode = document.createElement("link");
  fontsRegisterStylesheetNode.type = "text/css";
  fontsRegisterStylesheetNode.rel = "stylesheet";
  fontsRegisterStylesheetNode.href = APP_FONTS_REGISTER_STYLESHEET_HREF;

  const fontsStylesheetNode = document.createElement("link");
  fontsStylesheetNode.type = "text/css";
  fontsStylesheetNode.rel = "stylesheet";
  fontsStylesheetNode.href = APP_FONTS_STYLESHEET_HREF;

  return {
    appContainer,
    appRoot,
    modalNode,
    appStylesheetNode,
    fontsRegisterStylesheetNode,
    fontsStylesheetNode,
  };
};

const main = () => {
  const appRootNode: HTMLElement | null = document.getElementById("cabinet_root");
  if (!appRootNode) return;

  const { appContainer, appRoot, modalNode, appStylesheetNode, fontsRegisterStylesheetNode, fontsStylesheetNode } =
    createInitialNodes();

  appRootNode.appendChild(fontsRegisterStylesheetNode);
  appContainer.appendChild(fontsStylesheetNode);

  appContainer.appendChild(appRoot);
  appContainer.appendChild(modalNode);

  if (!__DEV_SERVER_LAUNCHED__) {
    appContainer.appendChild(appStylesheetNode);
  }

  appRootNode.appendChild(appContainer);

  if (__DEV_SERVER_LAUNCHED__) {
    createRoot(appRoot).render(<App />);
  } else {
    appStylesheetNode.addEventListener("load", () => {
      createRoot(appRoot).render(<App />);
    });
  }
};

if (__DEV_SERVER_LAUNCHED__) {
  main();
} else {
  (function checkForInit() {
    if (document.readyState === "complete") {
      return main();
    }
    window.requestAnimationFrame(() => {
      checkForInit();
    });
  })();
}
